import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import DropdownStyled from '../../../components/inputs/StyledInputs/DropdownStyled';
import MultipleSelectStyled from '../../../components/inputs/StyledInputs/MultipleSelectStyled';
import { useQuery } from '@tanstack/react-query';
import { fetchCompanies } from '../../../services/admin/UsersService';
import { getCompanyLabel } from '@/src/utils/formatUtils';
import { Company } from '../../../Interfaces/admin/User.interfaces';
import { getApprovalOrderSections } from '../../../services/admin/ApprovalSequences';
import { formatReportLabel } from '@/src/utils/roleUtils';

export type ApprovalSequenceFilters = {
  companies?: string[];
  report?: string;
};

const ApprovalSequenceFilters = () => {
  const { control } = useFormContext();

  const getCompany = useQuery({
    queryKey: ['getCompanies'],
    queryFn: () => fetchCompanies(),
    refetchOnWindowFocus: false,
  });

  const getApprovalOrderReports = useQuery({
    queryKey: ['getApprovalOrderReports'],
    queryFn: ({ signal }) => getApprovalOrderSections(signal),
    refetchOnWindowFocus: false,
  });

  return (
    <div className="flex flex-wrap justify-content-center align-items-end md:justify-content-start gap-4 form">
      <div className="w-15rem">
        <div className="text-standard mb-2">Companies</div>
        <Controller
          control={control}
          name="companies"
          render={({ field }) => (
            <MultipleSelectStyled
              isLoading={getCompany.isLoading}
              isDisabled={getCompany.isError}
              options={getCompany.data?.companies.map((company: Company) => ({
                ...company,
                label: getCompanyLabel(company),
              }))}
              labelField="label"
              valueField="id"
              placeholder={
                getCompany.isError
                  ? 'Failed to load companies!'
                  : 'Select company'
              }
              filter={true}
              resetFilterOnHide={true}
              {...field}
            />
          )}
        />
      </div>
      <div className="w-15rem">
        <div className="text-standard mb-2">Report</div>
        <Controller
          control={control}
          name="report"
          render={({ field }) => (
            <DropdownStyled
              isLoading={getApprovalOrderReports.isLoading}
              isDisabled={getApprovalOrderReports.isError}
              options={
                getApprovalOrderReports.data?.map((report) => ({
                  label: formatReportLabel(report),
                  id: report,
                })) ?? []
              }
              labelField="label"
              valueField="id"
              placeholder={
                getCompany.isError ? 'Failed to load reports!' : 'Select report'
              }
              filter={true}
              resetFilterOnHide={true}
              {...field}
            />
          )}
        />
      </div>
    </div>
  );
};

export default ApprovalSequenceFilters;
